import axios from 'axios';
import { message } from 'antd';
import { local } from 'brownies';

message.config({
  duration: 1.5,
});

let url = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_VERSION}`
const loginUrl = new URL(process.env.REACT_APP_NAVIGATION_URL)
const http = axios.create({
  baseURL: url,
  // headers: {
  //   'Cache-Control': 'no-cache',
  //   'Pragma': 'no-cache',
  //   'Expires': '0'
  // },
  withCredentials: true
});

const authUrl = process.env.REACT_APP_AUTH_API_URL;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

const authApi = axios.create({
  baseURL: authUrl,
  withCredentials: true
});

authApi.interceptors.request.use((config) => {
  const antiCsrfToken = getCookie('sAntiCsrf');
  
  if (antiCsrfToken) {
    config.headers['anti-csrf'] = antiCsrfToken;
  }
  
  config.headers['st-auth-mode'] = 'cookie';

  return config;
});

export { authApi };

const publisherReportsApiUrl = process.env.REACT_APP_PUBLISHER_REPORTS_API
const publisherReportsApi = axios.create({
  baseURL: publisherReportsApiUrl,
  withCredentials: true
})

export { publisherReportsApi }


// const getCookie = (name) => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts !== undefined && parts.length === 2) return parts.pop()?.split(";").shift() ?? null;
//   return null;
// };

// const decodeToken = (token) => {
//   return decodeURIComponent(token).replace(/^"|"$/g, '');
// }

// const tokenFromCookie = getCookie(`tts_token_${process.env.REACT_APP_COOKIE_DOMAIN}`);

http.interceptors.request.use(
  (config) => {
    // let token = local.access_token ? local.access_token : decodeToken(tokenFromCookie);
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${ token }`
    // }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
/**
* response handler
* Mostly intended to handle 401 error
*/

message.loading({ content: 'Loading...' })
http.interceptors.response
  .use(function (response) {
    if (response.status === 200) {
      if (typeof response.data.message !== 'undefined')
        message.success({ content: response.data.message })
    }
    return response;
  }, function (error) {
    switch (error.response.status) {
      case 401:
        alert("Session expired or unauthorized access. Redirecting to login page...");
        // local.access_token = null;
        local.isAuthenticated = null;
        local.expires_in = null;
        let url = error.response.config.url.split('/')
        if (url[url.length - 1] !== 'check') {
          // setTimeout(() => {
          // window.open(loginUrl.toString(), "_self");
          // }, 10000);
          window.open(loginUrl.toString(), "_self");
        }
        break;
      case 403:
        {
          const msg = error.response.data ? error.response.data.message : "Unauthorised access level";
          message.error({ content: msg })
        }
        break;
      case 404:
        message.error({ content: 'The requested api is not found in server. 404 error!' })
        break;
      default:
        {
          let ermgs = error.response.data ? error.response.data.message : 'Something went wrong!';
          message.error({ content: ermgs })
        }
    }
    return Promise.reject(error);
  });
export default http;
